










import {Component, Vue} from 'vue-property-decorator';
import Login from '@/oauth/Login.vue';
import CheckAgreement from "@/views/CheckAgreement.vue";
import {Strophe} from "@/xmpp/Strophe";
import {XmppUtils} from "@/xmpp/XmppUtils";
import {JiGuang} from "@/jiguang/JiGuang";
import router from "@/router";

@Component({
  components: {CheckAgreement, Login},
})
export default class Home extends Vue {
  checkToken(){
    const token = window.localStorage.getItem("AuthToken")as any
    const token1 = JSON.parse(token);
    if (token1!==null||token1!=''){
      this.loginSuccessful()
    }
  }
  connection!: Strophe.Connection;
  private loginSuccessful() {
    const item: string | null = localStorage.getItem('entryPoint');
    const xmppUtils = new XmppUtils();
    xmppUtils.xmppLogin();
    this.connection = XmppUtils.connection;
    // const jiGuang = new JiGuang();
    JiGuang.mount();
    if (item === null) {
      // router.go(-1);
      const location = "KeShangSelect" as any
      if (location.name !== this.$route.name) {
        router.replace(location);
      }
    } else {
      // console.log('+++++++')
      // setTimeout(()=>{
      //   window.location.reload();
      // },600000);
      const location = JSON.parse(item);
      if (location.name !== this.$route.name) {
        router.replace(location);
      }
    }

    // this.$router.push("/keShangSelect")
  }
  async mounted() {
    // await this.checkToken()
  }
}
